import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const FEEDBACK_LOCALES = [
  { code: 'ar-MA', name: 'العربية (المغرب)', nativeName: 'Darija marocaine' },
  { code: 'ar-DZ', name: 'العربية (الجزائر)', nativeName: 'Darija algérienne' },
  { code: 'de', name: 'Deutsch', nativeName: 'Allemand' },
  { code: 'en', name: 'English', nativeName: 'Anglais' },
  { code: 'es', name: 'Español', nativeName: 'Espagnol' },
  { code: 'fr', name: 'Français', nativeName: 'Français' },
  { code: 'pt', name: 'Português', nativeName: 'Portugais' },
  { code: 'ro', name: 'Română', nativeName: 'Roumain' },
  { code: 'tr', name: 'Türkçe', nativeName: 'Turc' },
  { code: 'uk', name: 'Українська', nativeName: 'Ukrainien' },
] as const;

export type FeedbackLocaleCode = (typeof FEEDBACK_LOCALES)[number]['code'];

export function useFeedbackLocale() {
  const { i18n } = useTranslation();
  const [overrideLocale, setOverrideLocale] = useState<FeedbackLocaleCode | null>(null);

  // Priority: override → flow language → fr-FR
  const feedbackLocale = useMemo(() => {
    if (overrideLocale) return overrideLocale;
    const flowLang = i18n.language;
    const matched = FEEDBACK_LOCALES.find(l => flowLang.startsWith(l.code));
    return matched?.code ?? 'fr';
  }, [overrideLocale, i18n.language]);

  const isRTL = feedbackLocale === 'ar-MA' || feedbackLocale === 'ar-DZ';

  const setOverride = useCallback((code: FeedbackLocaleCode | null) => {
    setOverrideLocale(code);
  }, []);

  return { feedbackLocale, isRTL, setOverride, availableLocales: FEEDBACK_LOCALES };
}
